export const PRE_MEETING_TEMPLATE_TYPE = {
  STRATEGY_PRIORITIES: 'strategy_priorities',
  FOLLOW_UP_ACCOUNTABILITY: 'follow_up_accountability',
  GOAL_PROGRESS_GROWTH: 'goal_progress_growth',
  PERFORMANCE_FEEDBACK: 'performance_feedback',
  FACTORIAL_FORMAT: 'suggestion_from_factorial',
}

export const POST_MEETING_TEMPLATE_TYPE = {
  FACTORIAL_FORMAT: 'factorial_format',
  TALK_AGREE_ACTION: 'talk_agree_action',
  DECISIONS_BLOCKERS_NEXT: 'decisions_blockers_next',
  WINS_CHALLENGES_FOCUS: 'wins_challenges_focus',
  ENHANCE_MY_NOTES: 'enhance_my_notes',
}
